import { useRef, useState } from "react";
import Webcam from "react-webcam";

const API_BASE_URL= process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

export default function SmartSelfie() {
  const webcamRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [userData, setUserData] = useState(null);

  const captureAndVerify = async () => {
    setError("");
    setSuccess("");
    setLoading(true);

    const imageSrc = webcamRef.current?.getScreenshot();
    if (!imageSrc) {
      setError("Camera access required to continue");
      setLoading(false);
      return;
    }

    const blob = await fetch(imageSrc).then((res) => res.blob());
    const file = new File([blob], "face.jpg", { type: "image/jpeg" });

    const formData = new FormData();
    formData.append("image", file);

    const token = localStorage.getItem("adminToken");
    if (!token) {
      setError("Session expired. Please login again.");
      setLoading(false);
      return;
    }

    try {
      const res = await fetch(`${API_BASE_URL}/user/face/register`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Face verification failed");
      } else {
        setSuccess("Face verified successfully ✅");
        setUserData(data.user || null);
      }
    } catch (err) {
      console.error("Face verify error:", err);
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.heading}>Face Registration</h2>
        <p style={styles.desc}>
          Please position your face clearly inside the frame
        </p>

        <div style={styles.cameraBox}>
          <Webcam
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={{ facingMode: "user" }}
            style={styles.webcam}
          />

          {loading && (
            <div style={styles.loader}>
              <div style={styles.spinner}></div>
              <span>Verifying…</span>
            </div>
          )}
        </div>

        {error && <div style={styles.errorBox}>{error}</div>}
        {success && <div style={styles.successBox}>{success}</div>}

        <button
          onClick={captureAndVerify}
          disabled={loading || success}
          style={{
            ...styles.button,
            opacity: loading || success ? 0.6 : 1,
          }}
        >
          {loading ? "Registring..." : success ? "Registered" : "Register Face"}
        </button>

        {userData && (
          <div style={styles.userInfo}>
            <strong>User Face Submit</strong>
            <p>{userData.name}</p>
            <p>{userData.email}</p>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #eef2ff, #f8fafc)",
    padding: 16,
  },
  card: {
    width: 380,
    background: "#fff",
    borderRadius: 16,
    padding: "28px 22px",
    boxShadow: "0 25px 60px rgba(0,0,0,0.1)",
    textAlign: "center",
  },
  heading: {
    fontSize: 22,
    fontWeight: 600,
    color: "#0f172a",
  },
  desc: {
    fontSize: 14,
    color: "#64748b",
    margin: "10px 0 20px",
  },
  cameraBox: {
    position: "relative",
    width: 240,
    height: 240,
    margin: "0 auto 18px",
    borderRadius: "50%",
    overflow: "hidden",
    border: "3px solid #6366f1",
    background: "#000",
  },
  webcam: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  loader: {
    position: "absolute",
    inset: 0,
    background: "rgba(0,0,0,0.65)",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  spinner: {
    width: 36,
    height: 36,
    border: "4px solid rgba(255,255,255,0.3)",
    borderTop: "4px solid #fff",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginBottom: 8,
  },
  button: {
    width: "100%",
    padding: 14,
    borderRadius: 10,
    border: "none",
    background: "#4f46e5",
    color: "#fff",
    fontSize: 16,
    fontWeight: 600,
    marginTop: 8,
    cursor: "pointer",
  },
  errorBox: {
    background: "#fee2e2",
    color: "#991b1b",
    padding: 10,
    borderRadius: 8,
    fontSize: 13,
    marginBottom: 10,
  },
  successBox: {
    background: "#dcfce7",
    color: "#166534",
    padding: 10,
    borderRadius: 8,
    fontSize: 13,
    marginBottom: 10,
  },
  userInfo: {
    marginTop: 14,
    fontSize: 13,
    color: "#334155",
  },
};
